export default function validateContactForm(values) {
  let errors = {}
  if (!values.name.trim())
    errors.name = values.name ? 'Name is Invalid' : 'Name is Required'
  if (/[`!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/i.test(values.name))
    errors.name = 'Name is Invalid'
  if (
    values.email &&
    !/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(
      values.email
    )
  )
    errors.email = 'Email is Invalid'
  else if (!values.email) errors.email = 'Email is Required'
  if (
    values.phone &&
    !/^(?:\+?1[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(
      values.phone
    )
  )
    errors.phone = 'Phone number is Invalid'
  else if (!values.phone) errors.phone = 'Phone number is Required'
  return errors
}
